import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { KYVIXE } from "@/lib/api";

const NAV = [
  { to: "/", label: "home" },
  { to: "/services", label: "services" },
  { to: "/industries", label: "industries" },
  { to: "/blog", label: "blog" },
  { to: "/faq", label: "faqs" },
  { to: "/contact", label: "contact" },
];

export default function Header() {
  const [open, setOpen] = React.useState(false);
  const loc = useLocation();

  React.useEffect(() => {
    setOpen(false);
  }, [loc.pathname]);

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#0a0a0f]/70 border-b border-white/5"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo-link">
          <span className="font-display text-2xl font-bold lowercase tracking-tighter">
            kyvixe<span className="text-blue-500">.</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-link-${n.label}`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-sm transition-all ${
                  isActive
                    ? "text-blue-400 bg-blue-500/10"
                    : "text-gray-300 hover:text-white hover:bg-white/5"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/contact#book"
            className="hidden md:inline-flex kyv-btn-primary text-sm"
            data-testid="nav-book-a-call-btn"
          >
            book a call
          </Link>
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden text-white p-2 rounded-full border border-white/10"
            aria-label="menu"
            data-testid="mobile-menu-btn"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 bg-[#0a0a0f]/95 backdrop-blur-xl">
          <div className="px-6 py-4 flex flex-col gap-2">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={`mobile-nav-link-${n.label}`}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-xl ${
                    isActive
                      ? "text-blue-400 bg-blue-500/10"
                      : "text-gray-200"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/contact#book"
              className="kyv-btn-primary text-center text-sm mt-2"
              data-testid="mobile-book-a-call-btn"
            >
              book a call
            </Link>
          </div>
        </div>
      )}
    </motion.header>
  );
}
